import { render, staticRenderFns } from "./page9.vue?vue&type=template&id=afdfdca4&scoped=true&"
import script from "./page9.vue?vue&type=script&lang=js&"
export * from "./page9.vue?vue&type=script&lang=js&"
import style0 from "./page9.vue?vue&type=style&index=0&id=afdfdca4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdfdca4",
  null
  
)

export default component.exports